var _ellipse, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5993",
    "data-name": "Group 5993",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.535,
    height: 18,
    viewBox: "0 0 18.535 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_962",
    "data-name": "Ellipse 962",
    cx: 9.268,
    cy: 9,
    rx: 9.268,
    ry: 9,
    transform: "translate(0)",
    fill: "#cf9661"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_15339",
    "data-name": "Path 15339",
    d: "M8.494,12.152V14h1.884V12.152ZM6.562,8.192H8.326a2.372,2.372,0,0,1,.072-.6A1.458,1.458,0,0,1,8.614,7.1,1.1,1.1,0,0,1,9,6.764a1.152,1.152,0,0,1,.564-.132,1.006,1.006,0,0,1,.744.264,1.082,1.082,0,0,1,.276.816.949.949,0,0,1-.12.54,1.5,1.5,0,0,1-.324.4q-.2.18-.444.36a2.875,2.875,0,0,0-.456.432,2.492,2.492,0,0,0-.384.588,2.554,2.554,0,0,0-.192.864v.54h1.62v-.456a1.258,1.258,0,0,1,.228-.6,2.383,2.383,0,0,1,.432-.42q.24-.192.5-.372a2.416,2.416,0,0,0,.492-.456,2.15,2.15,0,0,0,.372-.636,2.47,2.47,0,0,0,.156-.948A2.035,2.035,0,0,0,12.31,6.8a2.02,2.02,0,0,0-.492-.756,2.683,2.683,0,0,0-.924-.576,3.632,3.632,0,0,0-1.416-.24,3.056,3.056,0,0,0-1.2.228,2.654,2.654,0,0,0-.912.612A2.952,2.952,0,0,0,6.778,7,3.524,3.524,0,0,0,6.562,8.192Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/QuestionMark.cd5ba051a55e3f1da27cb6333e18c3bc.svg";
export { ForwardRef as ReactComponent };